import { NgModule } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { GlossaryService } from './glossary.service';

/**
 * We must import all api services here
 */

const apiServices = [
    AuthenticationService,
    GlossaryService,
]

@NgModule({
    providers: [...apiServices]
})
export class ApiModule {}
